import React from 'react'
import {IconProps, IconWrapper} from './IconWrapper'

const renderIcon = (color: string = "#37373E") => (
    <path
        d="M12 4V2M12 20V22M6.41421 6.41421L5 5M17.728 17.728L19.1422 19.1422M4 12H2M20 12H22M17.7285 6.41421L19.1427 5M6.4147 17.728L5.00049 19.1422M12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17Z"
        stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin={"round"}/>
)

export const Sun: React.FC<IconProps> = ({color, size}) =>
    <IconWrapper {...{size, color, renderIcon}} viewBox={`0 0 22 22`}/>
